module.exports = __webpack_public_path__ + "img/table.2f028f80.svg";